export default __webpack_public_path__ + "static/media/1.affa1865.png";